var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AwardsList',{on:{"reportEvent":_vm.handleReportEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }